import React from 'react';

import { IPackingTask } from 'commons/types/packingTask.interface';
import { TableConfig } from 'commons/types/tableConfig.interface';
import { formatDate } from 'commons/utils/formatDate';

const formatElement = (
  input?: number[] | number | string,
  bold = false,
): React.JSX.Element => {
  const text = input?.toString();
  return <div style={{ fontWeight: bold ? '700' : '400' }}>{text}</div>;
};

export const poDataConfig: TableConfig = [
  {
    header: 'PoNumber',
    key: 'po_number',
  },
  {
    header: 'Priority',
    element: (task: IPackingTask): React.ReactElement => {
      return formatElement(task.picking_task?.priority);
    },
  },
  {
    header: 'Basket(s)',
    element: (task: IPackingTask): React.ReactElement => {
      return formatElement(task.picking_task?.baskets);
    },
  },
  {
    header: 'Picker',
    element: (task: IPackingTask): React.ReactElement => {
      return formatElement(task.picking_task?.picker || '-');
    },
  },
  {
    header: 'Expected Dispatch',
    element: (task: IPackingTask): React.ReactElement => {
      const expectedDispatchTime =
        task.picking_task?.expected_dispatch_time &&
        task.picking_task.expected_dispatch_time !== ''
          ? formatDate(
              task.picking_task.expected_dispatch_time,
              'dd/LL/yyyy, HH:mm',
            )
          : '-';
      return formatElement(expectedDispatchTime);
    },
  },
  {
    header: 'Total SKU',
    element: (task: IPackingTask): React.ReactElement => {
      return formatElement(task.picking_task?.total_sku, true);
    },
  },
  {
    header: 'Total QTY',
    element: (task: IPackingTask): React.ReactElement => {
      const totalQty = task.picking_task.total_qty;
      const pickActualQty = task.basket_infos.reduce((total, basketInfo) => {
        return (
          total +
          basketInfo.items.reduce((basketTotal, item) => {
            return basketTotal + item.total_qty_picked;
          }, 0)
        );
      }, 0);
      return formatElement(`${pickActualQty}/${totalQty}`);
    },
  },
];
